import { render, staticRenderFns } from "./delivery_redirect.vue?vue&type=template&id=293d6d33"
import script from "./delivery_redirect.vue?vue&type=script&lang=js"
export * from "./delivery_redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports